const middleware = {}

middleware['adminAuthenticated'] = require('../../../middleware/adminAuthenticated.js')
middleware['adminAuthenticated'] = middleware['adminAuthenticated'].default || middleware['adminAuthenticated']

middleware['adminNotAuthenticated'] = require('../../../middleware/adminNotAuthenticated.js')
middleware['adminNotAuthenticated'] = middleware['adminNotAuthenticated'].default || middleware['adminNotAuthenticated']

middleware['hasPurchasedPoa'] = require('../../../middleware/hasPurchasedPoa.js')
middleware['hasPurchasedPoa'] = middleware['hasPurchasedPoa'].default || middleware['hasPurchasedPoa']

middleware['hasPurchasedWill'] = require('../../../middleware/hasPurchasedWill.js')
middleware['hasPurchasedWill'] = middleware['hasPurchasedWill'].default || middleware['hasPurchasedWill']

middleware['maintenance'] = require('../../../middleware/maintenance.js')
middleware['maintenance'] = middleware['maintenance'].default || middleware['maintenance']

middleware['prefix-router.middleware'] = require('../../../middleware/prefix-router.middleware.js')
middleware['prefix-router.middleware'] = middleware['prefix-router.middleware'].default || middleware['prefix-router.middleware']

middleware['redirect-if-logged-in.middleware'] = require('../../../middleware/redirect-if-logged-in.middleware.js')
middleware['redirect-if-logged-in.middleware'] = middleware['redirect-if-logged-in.middleware'].default || middleware['redirect-if-logged-in.middleware']

middleware['redirect-if-not-logged-in.middleware'] = require('../../../middleware/redirect-if-not-logged-in.middleware.js')
middleware['redirect-if-not-logged-in.middleware'] = middleware['redirect-if-not-logged-in.middleware'].default || middleware['redirect-if-not-logged-in.middleware']

middleware['userOnboardingPageRequired'] = require('../../../middleware/userOnboardingPageRequired.js')
middleware['userOnboardingPageRequired'] = middleware['userOnboardingPageRequired'].default || middleware['userOnboardingPageRequired']

export default middleware
